const RELOAD_KEY = 'managd:failed-chunk-reload';

export const getChunkFailureKey = reason => {
  const message = String(reason?.message || reason || '');
  if (!/ChunkLoadError|Loading (?:CSS )?chunk [\w.-]+ failed|Failed to fetch dynamically imported module/i.test(message)) {
    return '';
  }
  return message.replace(/\s+/g, ' ').slice(0, 500);
};

export const recoverFromChunkFailure = (reason, reload = () => window.location.reload()) => {
  const failureKey = getChunkFailureKey(reason);
  if (!failureKey || typeof window === 'undefined') return false;

  try {
    if (window.sessionStorage.getItem(RELOAD_KEY) === failureKey) return false;
    window.sessionStorage.setItem(RELOAD_KEY, failureKey);
  } catch {
    // A blocked session store should not prevent recovery.
  }

  reload();
  return true;
};

export const installChunkLoadRecovery = () => {
  if (typeof window === 'undefined' || window.__managdChunkRecoveryInstalled) return;
  window.__managdChunkRecoveryInstalled = true;
  window.addEventListener('error', event => recoverFromChunkFailure(event.error || event.message));
  window.addEventListener('unhandledrejection', event => recoverFromChunkFailure(event.reason));
};
